import {
  ChangeDetectionStrategy,
  Component,
  input,
  output,
} from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { NgCommonModule } from '@principle-theorem/ng-shared';
import { Observable } from 'rxjs';

@Component({
  selector: 'pr-referral-media-selection-item',
  imports: [NgCommonModule, MatIconModule, MatTooltipModule],
  templateUrl: './referral-media-selection-item.component.html',
  styleUrl: './referral-media-selection-item.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ReferralMediaSelectionItemComponent {
  name = input.required<string>();
  actorName = input.required<string>();
  isImage = input<boolean>(false);
  isSelected = input<boolean>(false);
  isDisabled = input<boolean>(false);
  tooltipText = input<string>('');
  thumbnailUrl$ = input.required<Observable<string | undefined>>();
  icon = input<string>('insert_drive_file');
  toggled = output<void>();
}
